// import React, { useState } from "react";
// import Product from "../components/product/ProductSelects";
// import {
//   Modal,
//   Tag,
//   Row,
//   Table,
//   Select,
//   Button,
//   Space,
//   Form,
//   Col,
//   Input,
//   InputNumber,
//   Card,
// } from "antd";
// import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
// import ProductSelectOrder from "../components/product/ProductSelectOrder";
// import { LocalImage } from "../components/ImageUtil";
// import { currencyFormat } from "../utils/index";
// import { useSelector } from "react-redux";

// import { productActions } from "../store";

// const confirm = Modal.confirm;

// const Test = () => {
//   const [show, setShow] = useState(false);
//   const [products, setProducts] = useState([]);
//   const [productSelects, setProductSelects] = useState([]);
//   const { form } = Form.useForm();
//   const { Option } = Select;

//   const { productSelectOrder } = useSelector((x) => x.product);

//   const onSelected = (data) => {
//     if (products.length > 0) {
//       setProducts([...products, data]);
//     } else {
//       setProducts(data);
//     }
//   };
//   const showWindow = () => {
//     setShow(!show);
//   };

//   const onOkModal = () => {
//     if (productSelectOrder.length === 0) {
//       confirm({
//         title: "Lưu ý .Bạn chưa chọn sản phẩm!?",
//         cancelText: "Hủy",
//         okText: "Tiếp tục",
//         onOk() {
//           setShow(!show);
//         },
//         onCancel() {},
//       });
//     } else {
//       console.log(productSelectOrder);
//       if (products.length > 0) {
//         setProducts([...products, ...productSelectOrder]);
//       } else {
//         setProducts(productSelectOrder);
//       }
//       setShow(!show);
//     }
//   };

//   const selectPrice = (record) => {
//     console.log(record);
//   };

//   const onSelectType = (value, option) => {
//     console.log(value, option);
//     const newState = products.map((obj, index) => {
//       if (option.index === index) {
//         return {
//           ...obj,
//           priceFinal: option.price,
//           salePriceFinal: option.salePrice,
//         };
//       }
//       return obj;
//     });
//     setProducts(newState);
//   };

//   const removeProduct = (index) => {
//     const items = [...products];
//     items.splice(index, 1);
//     setProducts([...items]);
//   };

//   const forMap = (item, index) => {
//     return (
//       <tr key={index}>
//         <td style={{ textAlign: "center" }}>
//           <LocalImage
//             src={item.avatar}
//             width={100}
//             style={{ objectFit: "contain" }}
//             height={100}
//           />
//         </td>

//         <td>
//           <b>{item.name}</b>
//         </td>
//         <td>
//           {item.variant ? (
//             <>
//               <Select
//                 name=""
//                 style={{ width: 250 }}
//                 defaultValue=""
//                 onChange={onSelectType}
//               >
//                 <Option
//                   value=""
//                   price={item.price}
//                   salePrice={item.salePrice}
//                   index={index}
//                 >
//                   --Không chọn--
//                 </Option>

//                 {item.variant.types.map((item, _index) => {
//                   return (
//                     <Option
//                       key={_index}
//                       value={item.name}
//                       price={item.price}
//                       salePrice={item.salePrice}
//                       index={index}
//                     >
//                       {item.name}
//                     </Option>
//                   );
//                 })}
//               </Select>
//             </>
//           ) : null}
//         </td>

//         <td>
//           <span className="price-no-sale">
//             {currencyFormat(item.priceFinal)}
//           </span>
//           <b> {currencyFormat(item.salePriceFinal)}</b>
//         </td>
//         <td>
//           <InputNumber min={1} defaultValue={item.quantity} />
//         </td>
//         <td>
//           <b> {currencyFormat(item.salePriceFinal)}</b>
//         </td>
//         <td style={{ textAlign: "center" }}>
//           <Button
//             type="primary"
//             size="small"
//             danger
//             onClick={() => {
//               removeProduct(index);
//             }}
//           >
//             <DeleteOutlined /> &nbsp; Xóa
//           </Button>
//         </td>
//       </tr>
//     );
//   };

//   const tagChild = products.map(forMap);

//   // const columns = [
//   //   {
//   //     title: "Ảnh hiển thị",
//   //     dataIndex: "avatar",
//   //     key: "avatar",
//   //     render: (avatar) => (
//   //       <>
//   //         <LocalImage
//   //           src={avatar}
//   //           width={100}
//   //           style={{ objectFit: "contain" }}
//   //           height={100}
//   //         />
//   //       </>
//   //     ),
//   //     width: "15%",
//   //     className: "text-center",
//   //   },
//   //   {
//   //     title: "Tên sản phẩm",
//   //     dataIndex: "name",
//   //     render: (text) => <h3>{text}</h3>,
//   //     width: "10%",
//   //   },
//   //   {
//   //     title: "Giá",
//   //     dataIndex: "originalPrice",
//   //     render: (text) => (
//   //       <Select placeholder="Vui lòng chọn giá bán">
//   //         <Select.Option value="role_admin">Giá bán</Select.Option>
//   //         <Select.Option value="role_seller">Giá khuyến mãi</Select.Option>
//   //         <Select.Option value="role_customer">Customer</Select.Option>
//   //       </Select>
//   //     ),
//   //     width: "30%",
//   //     className: "text-center",
//   //   },
//   //   // {
//   //   //   title: "Giá bán",
//   //   //   dataIndex: "price",
//   //   //   render: (text) => <label>{currencyFormat(text)}</label>,
//   //   //   width: "10%",
//   //   //   className: "text-center",
//   //   // },
//   //   // {
//   //   //   title: "Giá khuyến mãi",
//   //   //   dataIndex: "salePrice",
//   //   //   render: (text) => <label>{currencyFormat(text)}</label>,
//   //   //   width: "10%",
//   //   //   className: "text-center",
//   //   // },
//   //   {
//   //     title: "Số lượng",
//   //     dataIndex: "quantity",
//   //     render: (text) => <label>{text}</label>,
//   //     width: "5%",
//   //     className: "text-center",
//   //   },
//   //   {
//   //     title: "Hành động",
//   //     key: "action",
//   //     render: (_, record) => (
//   //       <Space size="middle">
//   //         <>
//   //           <Button
//   //             onClick={() => selectPrice(record)}
//   //             value="large"
//   //             icon={<EditOutlined />}
//   //           >
//   //             Sửa
//   //           </Button>
//   //         </>
//   //       </Space>
//   //     ),
//   //     width: 150,
//   //     className: "text-center",
//   //     // fixed: "right",
//   //   },
//   // ];

//   return (
//     <>
//       <div>
//         <Tag
//           className="my-tag"
//           onClick={showWindow}
//           style={{ cursor: "pointer" }}
//         >
//           Chọn sản phẩm <PlusOutlined />
//         </Tag>
//         <br /> <br />
//         <Card>
//           {" "}
//           <div className="product-tb">
//             <table>
//               <tbody>
//                 <tr>
//                   <th style={{ width: 150, textAlign: "center" }}>
//                     Ảnh sản phẩm
//                   </th>
//                   <th style={{ width: 150 }}>Tên sản phẩm</th>
//                   <th style={{ width: 250 }}>Phân loại</th>
//                   <th style={{ width: 250 }}>Đơn giá</th>
//                   <th style={{ width: 250 }}>Số lượng</th>
//                   <th style={{ width: 250 }}>Số tiền</th>
//                   <th style={{ width: 100 }}>Hành động</th>
//                 </tr>
//                 {tagChild}
//               </tbody>
//             </table>
//           </div>
//         </Card>
//         {show && (
//           <Modal
//             title=""
//             visible={show}
//             width={1300}
//             onOk={() => {
//               onOkModal();
//             }}
//             style={{ top: 20 }}
//             // okButtonProps={{
//             //   disabled: !products,
//             // }}
//             onCancel={() => {
//               setShow(false);
//             }}
//             destroyOnClose={true}
//           >
//             <div style={{ padding: "15px" }}>
//               <ProductSelectOrder onSelected={onSelected} />
//             </div>
//           </Modal>
//         )}
//       </div>
//     </>
//   );
// };

// export default Test;
import SliderCenterHome from "./Modules/SliderCenterHome";
const Test = () => {
  return (
    <>
      <SliderCenterHome />
    </>
  );
};
export default Test;
